import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input } from "antd";
import { API_URL } from "../../config";
import AntDesignTable from "../common/antTable/AntDesignTable";
const TransactionContainer = () => {
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${API_URL}/credit/transactions/`);
        setTransactions(response.data);
        setFilteredTransactions(response.data);
      } catch (error) {
        console.error(
          "There was an error fetching the transaction data!",
          error,
        );
      }
    };

    fetchTransactions();
  }, []);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filteredData = transactions.filter(
      (transaction) =>
        transaction.payment_intent_id.toLowerCase().includes(value) ||
        transaction.patient_id.toString().includes(value),
    );

    setFilteredTransactions(filteredData);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Patient ID",
      dataIndex: "patient_id",
      key: "patient_id",
    },
    {
      title: "Payment Intent ID",
      dataIndex: "payment_intent_id",
      key: "payment_intent_id",
    },
    {
      title: "Credit ID",
      dataIndex: "credit_id",
      key: "credit_id",
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
    },
  ];

  return (
    <React.Fragment>
      <Input
        placeholder="Search by Payment Intent ID or Patient ID"
        value={searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 16, width: 300 }}
      />
      <AntDesignTable columns={columns} tableData={filteredTransactions} />
    </React.Fragment>
  );
};

export default TransactionContainer;
